var Handlebars = require('/var/lib/jenkins/jobs/wunderman_resolution/workspace/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression, alias5=container.lambda;

  return "<div id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" class=\"map-full-width\"\n	data-api-key=\""
    + alias4(((helper = (helper = helpers.api_key || (depth0 != null ? depth0.api_key : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"api_key","hash":{},"data":data}) : helper)))
    + "\"\n	data-place-title=\""
    + alias4(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"title","hash":{},"data":data}) : helper)))
    + "\"\n	data-place-lat=\""
    + alias4(alias5(((stack1 = (depth0 != null ? depth0.place : depth0)) != null ? stack1.lat : stack1), depth0))
    + "\"\n	data-place-lng=\""
    + alias4(alias5(((stack1 = (depth0 != null ? depth0.place : depth0)) != null ? stack1.lng : stack1), depth0))
    + "\"\n	data-center-lat=\""
    + alias4(alias5(((stack1 = (depth0 != null ? depth0.center : depth0)) != null ? stack1.lat : stack1), depth0))
    + "\"\n	data-center-lng=\""
    + alias4(alias5(((stack1 = (depth0 != null ? depth0.center : depth0)) != null ? stack1.lng : stack1), depth0))
    + "\"\n	>\n\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/map.hbs
// module id = 22
// module chunks = 0